import { useFlags } from 'launchdarkly-react-client-sdk';
import { graphql } from 'src/gql';
import { useInterval } from 'usehooks-ts';

import { USER_PROFILE_ADVISOR } from '@savvy/constants/user-profiles';
import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import {
  SALESFORCE_ACCESS_TOKEN_EXPIRATION,
  setSalesforceAccessToken,
} from '@savvy/deprecated-shared/utils/salesforce';
import { isLoggedIn } from '@savvy/deprecated-shared/utils/savvy-auth';
import { useMutationWithErrorLogging } from '@savvy/graphql-hooks/useMutationWithErrorLogging';

const GENERATE_SF_ACCESS_TOKEN = graphql(/* GraphQL */ `
  mutation GenerateSalesforceAccessToken($input: GenerateSalesforceAccessTokenInput!) {
    generateSalesforceAccessToken(input: $input) {
      accessToken
    }
  }
`);

const ONE_SECOND = 1000;

export default function useSalesforceReAuth() {
  const { offSalesforceOauth } = useFlags();
  const authEnabled = offSalesforceOauth !== true;
  const [generateSalesforceAccessToken] = useMutationWithErrorLogging(GENERATE_SF_ACCESS_TOKEN);
  const { user } = useAuth();

  useInterval(() => {
    if (!authEnabled) {
      return;
    }

    const storedExpirationTime = localStorage.getItem(SALESFORCE_ACCESS_TOKEN_EXPIRATION);

    if (
      user?.profileType === USER_PROFILE_ADVISOR &&
      storedExpirationTime &&
      new Date().getTime() > parseInt(storedExpirationTime)
    ) {
      isLoggedIn().then((loggedIn) => {
        if (!loggedIn) {
          return;
        }
        generateSalesforceAccessToken({
          variables: {
            input: {},
          },
        })
          .then(({ data }) => {
            const accessToken = data?.generateSalesforceAccessToken?.accessToken;
            if (accessToken) {
              setSalesforceAccessToken(accessToken);
            }
          })
          .catch(() => {
            // Refresh the page to get a new access token
            window.location.reload();
          });
      });
    }
  }, ONE_SECOND);
}
